export default __webpack_public_path__ + "9c87530c49106ef674814c8639a5f9f4.png";